import { RoleId } from "@/entities/role";
import { Policy } from "@/policies";
import debug from "debug";
const policyNamespace = "submission";

interface Context {
  userEntityId: unknown;
  entityId: unknown;
  userRoleId: unknown;
}

function isContext(obj: unknown): obj is Context {
  const tmp = obj as Context;

  return (
    tmp.entityId !== undefined &&
    tmp.userEntityId !== undefined &&
    tmp.userRoleId !== undefined
  );
}

const publisherAndEntityOficial: Policy = {
  async can(context: unknown) {
    if (!isContext(context)) {
      debug("publisherAndEntityOficialPolicy")({ context });
      throw new Error("Invalid context for policy");
    }
    return (
      context.entityId == context.userEntityId &&
      (context.userRoleId == RoleId.Publisher ||
        context.userRoleId == RoleId.EntityOficial)
    );
  },
};

const entityOficial: Policy = {
  async can(context: unknown) {
    if (!isContext(context)) {
      debug("entityOficialPolicy")("%O", { context });
      throw new Error("Invalid context for policy");
    }
    return (
      context.entityId == context.userEntityId &&
      context.userRoleId == RoleId.EntityOficial
    );
  },
};
const policyMap = new Map();

policyMap.set(`${policyNamespace}/create`, publisherAndEntityOficial);
policyMap.set(`${policyNamespace}/manage-settings`, entityOficial);
policyMap.set(`${policyNamespace}/view`, publisherAndEntityOficial);
policyMap.set(`${policyNamespace}/delete`, entityOficial);
policyMap.set(`${policyNamespace}/disable`, entityOficial);

export default policyMap;
